export default {
    headData: [
        {
            title: '文件名',
            prop: 'fileName',
            width: '150'
        },
        {
            title: '导入结果',
            prop: 'result',
            width: '150',
            custom:true,
        },
        {
            title: '正确条数',
            prop: 'rightCount',
            width: '150'
        },
        {
            title: '错误条数',
            prop: 'errorCount',
            width: '150'
        },
        {
            title: '导入时间',
            prop: 'createTime',
            width: '150'
        },
    ],
    //页码
    pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        paginationkey: 0
    },
}
